import React, { useState, useEffect } from 'react';
import axios from 'axios';
import styles from './OverviewTab.module.css';

const OverviewTab = ({ user, missions, onViewMissions, onViewProgress, assignedLessons = [], onViewLessons, assignedQuizzes = [], onViewQuizzes, tabId = "overview", tabLabel = "Overview" }) => {
  const [teacherName, setTeacherName] = useState(null);

  // Fetch teacher name for students
  useEffect(() => {
    const fetchTeacherName = async () => {
      if (user && user.userType === 'student' && user.teacherCode) {
        try {
          const response = await axios.get(`/api/teacher/by-code/${user.teacherCode}`);
          if (response.data.success) {
            setTeacherName(response.data.teacher.contactName);
          }
        } catch (error) {
          console.error('Error fetching teacher name:', error);
        }
      }
    };

    fetchTeacherName();
  }, [user]);
  return (
    <div tabId={tabId} tabLabel={tabLabel} className={styles.overviewContainer}>
      <div className={styles.cardsGrid}>
        <div className={styles.card}>
          <div className={styles.cardBody}>
            <h5 className={styles.cardTitle}>Welcome, {user?.contactName}!</h5>
            <div className={styles.cardContent}>
              <strong>Student Code:</strong> {user?.studentCode}<br/>
              <strong>Year Group:</strong> {user?.yearGrade || 'Not set'}<br/>
              <strong>Teacher:</strong> {teacherName ? `${teacherName} (${user?.teacherCode})` : (user?.teacherCode ? `Connected (${user.teacherCode})` : 'Not connected')}
            </div>
          </div>
        </div>
        
        <div className={styles.card}>
          <div className={styles.cardBody}>
            <h5 className={styles.cardTitle}>My Missions</h5>
            <div className={styles.cardContent}>
              <strong>Assigned:</strong> {missions.filter(m => m.status === 'assigned').length}<br/>
              <strong>In Progress:</strong> {missions.filter(m => m.status === 'in-progress').length}<br/>
              <strong>Completed:</strong> {missions.filter(m => m.status === 'completed').length}<br/>
              <strong>Re-assigned:</strong> {missions.filter(m => m.progress?.reassignedAt).length}<br/>
              <strong>Total:</strong> {missions.length}
            </div>
            <button className={styles.cardButton} onClick={onViewMissions}>View Missions</button>
          </div>
        </div>
        
        <div className={styles.card}>
          <div className={styles.cardBody}>
            <h5 className={styles.cardTitle}>Progress</h5>
            <div className={styles.cardContent}>
              <strong>Level:</strong> {user?.progress?.level || 1}<br/>
              <strong>Points:</strong> {user?.progress?.totalPoints || 0}<br/>
              <strong>Badges:</strong> {user?.badges?.length || 0}
            </div>
            <button className={styles.cardButton} onClick={onViewProgress}>View Progress</button>
          </div>
        </div>
        
        <div className={styles.card}>
          <div className={styles.cardBody}>
            <h5 className={styles.cardTitle}>My Lessons</h5>
            <div className={styles.cardContent}>
              <strong>Assigned:</strong> {assignedLessons.filter(l => l.status === 'assigned').length}<br/>
              <strong>In Progress:</strong> {assignedLessons.filter(l => l.status === 'in_progress').length}<br/>
              <strong>Completed:</strong> {assignedLessons.filter(l => l.status === 'completed').length}<br/>
              <strong>Total:</strong> {assignedLessons.length}
            </div>
            <button className={styles.cardButton} onClick={onViewLessons}>View Lessons</button>
          </div>
        </div>
        
        <div className={styles.card}>
          <div className={styles.cardBody}>
            <h5 className={styles.cardTitle}>My Quizzes</h5>
            <div className={styles.cardContent}>
              <strong>Assigned:</strong> {assignedQuizzes.filter(q => q.assignmentStatus === 'assigned').length}<br/>
              <strong>In Progress:</strong> {assignedQuizzes.filter(q => q.assignmentStatus === 'in-progress').length}<br/>
              <strong>Completed:</strong> {assignedQuizzes.filter(q => q.assignmentStatus === 'completed').length}<br/>
              <strong>Total:</strong> {assignedQuizzes.length}
            </div>
            <button className={styles.cardButton} onClick={onViewQuizzes}>View Quizzes</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OverviewTab; 